// import React from 'react';
// import './whatsapp.scss'; // For styling

// const WhatsAppWidget = () => {
//   const phoneNumber = '551143285068';  // Replace with your WhatsApp number (in international format, no +)

//   const handleClick = () => {
//     window.gtag('config', 'AW-976473031')
//     window.gtag('event', 'conversion', {
//       'send_to': 'AW-976473031/Ur-fCN6ymoIaEMeXz9ED',
//       'value': 0,
//       'currency': 'BRL',
//       'transaction_id': ''
//     });
//     window.dataLayer = window.dataLayer || [];
//     window.dataLayer.push({
//       'event': 'whatsapp_click'
//     });
//     window.open(`https://wa.me/${phoneNumber}?`, '_blank');

//   };

//   return (
//     <div className="whatsapp-widget" onClick={handleClick}>
//       <img src="/images/whatsapp.svg" alt="WhatsApp" />
//     </div>
//   );
// };

// export default WhatsAppWidget;

import React, { useState, useRef, useEffect } from 'react';
import './whatsapp.scss'; // For styling
import { useTranslation } from 'react-i18next';

const WhatsAppWidget = () => {

  const { t } = useTranslation();
  
  const phoneNumber = '551143285068';  // Replace with your WhatsApp number (in international format, no +)
  const [isFormOpen, setIsFormOpen] = useState(false);
  const formRef = useRef(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: ''
  });

  const handleClick = () => {
    setIsFormOpen(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Track the event
    window.gtag('config', 'AW-976473031');
    window.gtag('event', 'conversion', {
      'send_to': 'AW-976473031/Ur-fCN6ymoIaEMeXz9ED',
      'value': 0,
      'currency': 'BRL',
      'transaction_id': ''
    });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'whatsapp_click'
    });
    
    // Create pre-filled message
    const message = `${t('whatsapp.message.greeting')} ${formData.name} ${t('whatsapp.message.from')} ${formData.company}. ${t('whatsapp.message.email')} ${formData.email}. ${t('whatsapp.message.learn_more')}`;
    const encodedMessage = encodeURIComponent(message);
    
    // Open WhatsApp with pre-filled message
    window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, '_blank');
    
    // Close the form after submission
    setIsFormOpen(false);
  };

  const handleClose = () => {
    setIsFormOpen(false);
  };

  // Close the form when clicking outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (formRef.current && !formRef.current.contains(event.target) && 
          !event.target.closest('.whatsapp-widget')) {
        setIsFormOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="whatsapp-container">
      <div className={`whatsapp-widget ${isFormOpen ? 'active' : ''}`} onClick={handleClick}>
        <img src="/images/whatsapp.svg" alt="WhatsApp" />
      </div>
      
      <div className={`whatsapp-chat-box ${isFormOpen ? 'open' : ''}`} ref={formRef}>
        <div className="chat-header">
          <div className="chat-title">
            <img src="/images/whatsapp.svg" alt="WhatsApp" className="header-icon" />
            <span>WhatsApp Chat</span>
          </div>
          <button className="close-button" onClick={handleClose}>×</button>
        </div>
        <div className="chat-body">
          <div className="chat-message">
            <p>{t('whatsapp.intro_text')}</p>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">{t('whatsapp.name')}</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder={t('whatsapp.name')}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="email@email.com"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="company">{t('whatsapp.company')}</label>
              <input
                type="text"
                id="company"
                name="company"
                value={formData.company}
                onChange={handleChange}
                placeholder={t('whatsapp.company')}
                required
              />
            </div>
            <button type="submit" className="submit-button">
            {t('whatsapp.button_text')}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default WhatsAppWidget;